import React from 'react';

import styles from "./Cart.module.css";
import { formatToLocaleString } from "../../utils/formatters/index.ts";
import { cartOneIcon } from "../../assets/icons/icons.ts";
import { useScreenDetector } from "../../hooks/useScreenDetector.ts";
import { cn } from "../../utils/cn.ts";
import { Icon } from "../../ui/General/Icon/Icon.tsx";
import { CartPopup } from "../CartPopup/CartPopup.tsx";
import { CartProduct } from "../ProductCard/types/productCard.interface.ts";
import { RootState, useAppSelector } from '@/utils/storage/stores/store.ts';

export const Cart: React.FC = () => {
    const { isMobile, isDesktop } = useScreenDetector();
    const addedCartElement: CartProduct | null = useAppSelector((state: RootState) => state.cart.addedCartElement);
    const miniCart = useAppSelector((state: RootState) => state.cart.miniCart);

    return (
        <div className={cn(styles.cart)}>
            <div className={styles.counterWrapper} onClick={() => {
                document.location = '/cart';
            }}>
                {miniCart && miniCart.elementsQuantity > 0 ? <div className={styles.counter}>{miniCart && miniCart.elementsQuantity}</div> : null}

                {isMobile && <Icon name='cart' width={24} height={24} />}
                {isDesktop && <img src={cartOneIcon} alt='Корзина' />}
            </div>
            <div className={styles.sum} onClick={() => {
                document.location = '/cart';
            }}>
                {miniCart && miniCart.remainingPaymentAmount ?
                    <div>{formatToLocaleString(String(miniCart.remainingPaymentAmount))} ₽</div> : (isMobile ?
                        <div style={{ color: '#fff', fontWeight: 'normal', marginTop: 2, }}>Корзина</div> : <div style={{ color: '#000', fontWeight: 'normal' }}>Корзина</div>)}
            </div>

            {
                isDesktop && addedCartElement && miniCart
                    ? <div className={cn(styles.popup)}>
                        <CartPopup product={addedCartElement} />
                    </div>
                    : null
            }

            {
                isMobile && addedCartElement && miniCart
                    ? <div className={styles.popup} >
                        <CartPopup product={addedCartElement} />
                    </div>
                    : null
            }
        </div>
    );
};